<div [class.main-right-content]="!inCustomer">
  <div [class.manageUser]="!inCustomer">
    <div *ngIf="!inCustomer"
      class="d-flex flex-column flex-lg-row align-items-start justify-content-between manage-top gap-4">
      <h1 class="title mb-0">Backorder Product</h1>
    </div>
    <div class="mt-3">
      <app-search [sortText]="getSortText()" [sortOptions]="sortOptions" (searchChanged)="updateSearchTerm($event)"
        (sortChanged)="updateSortField($event)"></app-search>
    </div>

    <div class="d-flex align-items-start justify-content-between">
      <app-advanced-filter (search)="onSearch($event)" [filterType]="filterType">
      </app-advanced-filter>
      <div class="d-flex flex-column flex-lg-row align-items-end justify-content-end manage-top gap-4">
        <button class="btn btn-secondary mb-3" routerLink="/manage/customer/backorder/logs" *ngIf="inCustomer"
          [queryParams]="{customerId : customerId}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M11 21.95q-1.9-.2-3.537-1.037t-2.85-2.175T2.7 15.675T2 12q0-2.275.913-4.2T5.4 4.5H3v-2h6v6H7V5.775q-1.375 1.1-2.187 2.713T4 12q0 3.075 2.013 5.313T11 19.925zm-.425-5.35L6.35 12.35l1.4-1.4l2.825 2.825L16.25 8.1l1.4 1.425zM15 21.5v-6h2v2.725q1.375-1.125 2.188-2.725T20 12q0-3.075-2.013-5.312T13 4.075V2.05q3.8.375 6.4 3.2T22 12q0 2.275-.913 4.2T18.6 19.5H21v2z" />
          </svg>
          View Logs
        </button>

        <button class="btn btn-secondary mb-3" (click)="generateSubstituteReport('All')">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="18"
            height="18" x="0" y="0" viewBox="0 0 24 24" style="enable-background: new 0 0 512 512" xml:space="preserve"
            class="">
            <g>
              <switch>
                <g>
                  <path
                    d="M8.7 7.7 11 5.4V15c0 .6.4 1 1 1s1-.4 1-1V5.4l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1 0-.2.1-.3.2l-4 4c-.4.4-.4 1 0 1.4s1 .4 1.4 0zM21 14c-.6 0-1 .4-1 1v4c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-4c0-.6-.4-1-1-1s-1 .4-1 1v4c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-4c0-.6-.4-1-1-1z"
                    fill="currentColor" opacity="1" data-original="currentColor"></path>
                </g>
              </switch>
            </g>
          </svg>
          Export All
        </button>

        <div class="sorted gap-4 mb-3">
          <div class="dropdown" *ngIf="selectedProductIds.size >= 1">
            <button class="btn btn-primary text-white dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              Bulk Action
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" style="min-width: 270px">
              <li>
                <a class="dropdown-item d-flex align-items-center gap-2 text-nowrap" [ngbTooltip]="
                !hasValidStatusForBulk()
                  ? 'Selected Product\'s Status Must Be Other Than No Substitute'
                  : null
              " tooltipClass="custom-tooltip" [class.text-danger]="!hasValidStatusForBulk()"
                  (click)="bulkMarkAsNoSubstitute()">
                  Mark as no substitute
                </a>
              </li>
              <li>
                <a class="dropdown-item d-flex align-items-center gap-2 text-nowrap" [ngbTooltip]="
                !hasValidStatusForBulk()
                  ? 'Selected Product\'s Status Must Be Other Than No Substitute'
                  : null
              " tooltipClass="custom-tooltip" [class.text-danger]="!hasValidStatusForBulk()"
                  (click)="generateSubstituteReport('Selected')">
                  Export Selected Products
                </a>
              </li>
              <li>
                <a class="dropdown-item d-flex align-items-center gap-2 text-nowrap" [ngbTooltip]="
                !canChangeRuleToApproval()
                  ? 'Selected Product\'s Rule Must Be Auto Swap'
                  : null
              " tooltipClass="custom-tooltip" [class.text-danger]="!canChangeRuleToApproval()"
                  (click)="bulkApplyApprovalRule()">
                  Apply “Require Approval Per Order” Rule
                </a>
              </li>
              <li>
                <a class="dropdown-item d-flex align-items-center gap-2 text-nowrap" [ngbTooltip]="
                !canSendBulkApprovalRequest() || !customer.enableSubstituteApproval
                  ? getSendBulkErrorText()
                  : null
              " tooltipClass="custom-tooltip"
                  [class.text-danger]="!canSendBulkApprovalRequest() || !customer.enableSubstituteApproval"
                  (click)="openEmailPreview()">
                  Send multiple substitute approval requests
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="manage-user-list">
      <div class="manage-table main-table table-responsive d-none d-lg-block">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" *ngIf="inCustomer">
                <input type="checkbox" class="form-check-input" id="selectAll" (change)="toggleSelectAllProductIds()"
                  [checked]="isAllProductIdsSelected()" style="height: 15px; width: 17px" />
              </th>
              <th scope="col">Product Image</th>
              <th scope="col">Product Name</th>
              <th scope="col">Product Code</th>
              <th scope="col">Backorder Rule</th>
              <th scope="col">Substitute Product</th>
              <th scope="col">Substitute Product Code</th>
              <th scope="col">Approved User By</th>
              <th scope="col">Approved Date</th>
              <th scope="col">Status</th>
              <th scope="col" *ngIf="inCustomer">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of queryResult.rows; let i = index">
              <td *ngIf="inCustomer">
                <span>
                  <input type="checkbox" class="form-check-input" [id]="item.id" (change)="toggleSelectProductId(item)"
                    [checked]="isProductIdSelected(item.id)" />
                </span>
              </td>

              <td>
                <div class="product-name">
                  <span class="imgs">
                    <img src="{{
                    item.product.imageUrl ||
                      'https://placehold.co/600x400?text=No+Image'
                  }}" alt="product-1" />
                  </span>
                </div>
              </td>

              <td>
                <div class="user-name">
                  <h5>{{ item.product.name || "N/A" }}</h5>
                </div>
              </td>

              <td>
                <p>{{ item.product.code || "N/A" }}</p>
              </td>

              <td>
                <p>{{ getRuleText(item.substituteRule!) || "N/A" }}</p>
              </td>

              <td>
                <p>{{ item.substituteProduct?.name || "N/A" }}</p>
              </td>

              <td>
                <p>{{ item.substituteProduct?.code || "N/A" }}</p>
              </td>

              <td>
                <p>
                  {{
                  item.approvedByUser
                  ? item.approvedByUser.firstName +
                  " " +
                  item.approvedByUser.lastName
                  : "N/A"
                  }}
                </p>
              </td>

              <td>
                <p>{{ (item.approveDate | date: "yyyy-MM-dd") || "N/A" }}</p>
                <p>{{ item.approveDate | date: "HH:MM" }}</p>
              </td>

              <td>
                <span class="badge bg-{{ fetchColor(item.status!) }}-25">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="2" fill="transparent"></circle>
                  </svg>
                  {{ getStatusText(item.status!) || "N/A" }}
                </span>
              </td>

              <td *ngIf="inCustomer">
                <div class="d-flex align-items-center justify-content-start">
                  <div class="dropdown">
                    <button class="btn btn-more dropdown-toggle" type="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M10 16C10.4142 16 10.75 15.6642 10.75 15.25C10.75 14.8358 10.4142 14.5 10 14.5C9.58579 14.5 9.25 14.8358 9.25 15.25C9.25 15.6642 9.58579 16 10 16Z"
                          stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M10 10.75C10.4142 10.75 10.75 10.4142 10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10C9.25 10.4142 9.58579 10.75 10 10.75Z"
                          stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M10 5.5C10.4142 5.5 10.75 5.16421 10.75 4.75C10.75 4.33579 10.4142 4 10 4C9.58579 4 9.25 4.33579 9.25 4.75C9.25 5.16421 9.58579 5.5 10 5.5Z"
                          stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <ul class="dropdown-menu more-menu">
                      <ul class="drop-list-menu">
                        <li class="drop-item" *ngIf="item.substituteProduct">
                          <a class="dropdown-link" role="button" (click)="openNoSubstituteModal(item.id)">
                            No Substitute
                          </a>
                        </li>
                        <li class="drop-item" *ngIf="!item.substituteProduct">
                          <a class="dropdown-link" role="button" (click)="
                          openSendSubstituteApprovalRequestModal(
                            Send_Substitute_Approval_Request,
                            item,
                            'SEND'
                          )
                        ">
                            Send Substitute Approval Request
                          </a>
                        </li>
                        <li class="drop-item" *ngIf="item.substituteProduct">
                          <a class="dropdown-link" role="button" (click)="
                          openSendSubstituteApprovalRequestModal(
                            Send_Substitute_Approval_Request,
                            item,
                            'OVERRIDE'
                          )
                        ">
                            Approved Substitute Override
                          </a>
                        </li>
                      </ul>
                    </ul>
                  </div>
                  <a ngbTooltip="View Details" [routerLink]="'/manage/customer/backorder/' + item.id"
                    tooltipClass="custom-tooltip" [openDelay]="0" class="btn btn-edit" role="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                      <path d="M5.25 10H15.75" stroke="#818898" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                      <path d="M10.5 4.75L15.75 10L10.5 15.25" stroke="#666D80" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </a>
                </div>
              </td>
            </tr>

            <tr *ngIf="queryResult.rows.length === 0">
              <td colspan="10">
                <div class="no-results-content">
                  <div class="no-result-img for-admin">
                    <img src="../../../../assets/images/No-result.png" alt="No-result" />
                  </div>
                  <h4 class="title">No Results Found!</h4>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="manage-cards d-lg-none">
        <div class="card manage-card" *ngFor="let item of queryResult.rows">
          <div class="card-body">
            <ul class="card-list">
              <li>
                <div class="manage-grid">
                  <span class="head">Product</span>
                  <div class="product-name">
                    <span class="imgs">
                      <img [src]="
                      item.product.imageUrl ||
                      'https://placehold.co/600x400?text=No+Image'
                    " class="img-fluid rounded" style="width: 50px; height: 50px; object-fit: cover" />
                    </span>
                    <h6 class="mt-2">{{ item.product.name || "N/A" }}</h6>
                    <p class="text-muted mb-0">{{ item.product.code || "N/A" }}</p>
                  </div>
                </div>
              </li>

              <li>
                <div class="manage-grid">
                  <span class="head">Backorder Rule</span>
                  <p>{{ getRuleText(item.substituteRule!) || "N/A" }}</p>
                </div>
              </li>

              <li>
                <div class="manage-grid">
                  <span class="head">Substitute Product</span>
                  <p>{{ item.substituteProduct?.name || "N/A" }}</p>
                </div>
              </li>

              <li>
                <div class="manage-grid">
                  <span class="head">Substitute Product Code</span>
                  <p>{{ item.substituteProduct?.code || "N/A" }}</p>
                </div>
              </li>

              <li>
                <div class="manage-grid">
                  <span class="head">Approved By User</span>
                  <p>
                    {{
                    item.approvedByUser
                    ? item.approvedByUser.firstName +
                    " " +
                    item.approvedByUser.lastName
                    : "N/A"
                    }}
                  </p>
                </div>
              </li>

              <li>
                <div class="manage-grid">
                  <span class="head">Approved Date</span>
                  <p>{{ (item.approveDate | date: "yyyy-MM-dd") || "N/A" }}</p>
                  <p>{{ item.approveDate | date: "HH:MM" }}</p>
                </div>
              </li>

              <li>
                <div class="manage-grid">
                  <span class="head">Status</span>
                  <span class="badge bg-{{ fetchColor(item.status!) }}-25">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="2" fill="transparent"></circle>
                    </svg>
                    {{ getStatusText(item.status!) || "N/A" }}
                  </span>
                </div>
              </li>

              <li *ngIf="inCustomer">
                <div class="manage-grid">
                  <span class="head">Actions</span>

                  <div class="d-flex align-items-center w-100 justify-content-end">
                    <!-- 3 dot button -->
                    <button class="btn btn-more" type="button" data-bs-toggle="offcanvas"
                      [attr.data-bs-target]="'#backorderActions' + item.id" aria-controls="backorderActions">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M10 16C10.4142 16 10.75 15.6642 10.75 15.25C10.75 14.8358 10.4142 14.5 10 14.5C9.58579 14.5 9.25 14.8358 9.25 15.25C9.25 15.6642 9.58579 16 10 16Z"
                          stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M10 10.75C10.4142 10.75 10.75 10.4142 10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10C9.25 10.4142 9.58579 10.75 10 10.75Z"
                          stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M10 5.5C10.4142 5.5 10.75 5.16421 10.75 4.75C10.75 4.33579 10.4142 4 10 4C9.58579 4 9.25 4.33579 9.25 4.75C9.25 5.16421 9.58579 5.5 10 5.5Z"
                          stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>

                    <!-- Offcanvas -->
                    <div class="offcanvas more-offcanvas offcanvas-bottom" tabindex="-1"
                      [id]="'backorderActions' + item.id" aria-labelledby="backorderActionsLabel">
                      <div class="offcanvas-body">
                        <!-- Header -->
                        <div class="drop-head d-flex justify-content-between align-items-start">
                          <div>
                            <p class="desc mb-0">
                              {{
                              item.product && item.product.code
                              ? item.product.code
                              : "N/A"
                              }}
                            </p>
                          </div>

                          <button type="button" class="btn btn-secondary-icon p-2 shadow-none"
                            data-bs-dismiss="offcanvas">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                              fill="none">
                              <path d="M14.5 5.5L5.5 14.5M5.5 5.5L14.5 14.5" stroke="#666D80" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                        </div>

                        <hr class="solid-line" />

                        <!-- Actions -->
                        <ul class="more-menu">
                          <li class="drop-item" *ngIf="item.substituteProduct">
                            <a class="dropdown-link" role="button" (click)="openNoSubstituteModal(item.id)">
                              No Substitute
                            </a>
                          </li>

                          <li class="drop-item" *ngIf="!item.substituteProduct">
                            <a class="dropdown-link" role="button" (click)="
                            openSendSubstituteApprovalRequestModal(
                              Send_Substitute_Approval_Request,
                              item,
                              'SEND'
                            )
                          ">
                              Send Substitute Approval Request
                            </a>
                          </li>

                          <li class="drop-item" *ngIf="item.substituteProduct">
                            <a class="dropdown-link" role="button" (click)="
                            openSendSubstituteApprovalRequestModal(
                              Send_Substitute_Approval_Request,
                              item,
                              'OVERRIDE'
                            )
                          ">
                              Approved Substitute Override
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <a ngbTooltip="View Details" [routerLink]="'/manage/customer/backorder/' + item.id"
                      tooltipClass="custom-tooltip" [openDelay]="0" class="btn btn-edit" role="button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path d="M5.25 10H15.75" stroke="#818898" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"></path>
                        <path d="M10.5 4.75L15.75 10L10.5 15.25" stroke="#666D80" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="no-results-content" *ngIf="queryResult.rows.length === 0">
          <div class="no-result-img for-admin">
            <img src="../../../../assets/images/No-result.png" alt="No-result" />
          </div>
          <h4 class="title">No Results Found!</h4>
        </div>
      </div>
    </div>

    <app-pagination [currentPage]="currentPageActive" [pageSize]="query.limit" [totalRows]="totalCountActive"
      (pageChange)="pageChangedActive($event)" (pageSizeChange)="pageSizeChanged($event)"></app-pagination>
  </div>
</div>

<ng-template #Send_Substitute_Approval_Request let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="sendSubstituteApprovalRequestLabel">
        {{
        this.modalType === "SEND"
        ? "Send Substitute Approval Request"
        : "Override Substitute Product"
        }}
      </h5>
      <button type="button mb-2" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.close()"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 mb-4" *ngIf="selectedProduct">
          <div class="form-group">
            <label for="product" class="form-label">Selected Original Product</label>
            <div class="manage-table main-table table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <div class="product-name">
                        <span class="imgs">
                          <img src="{{
                              selectedProduct.imageUrl ||
                                'https://placehold.co/600x400?text=No+Image'
                            }}" alt="product-1" />
                        </span>
                      </div>
                    </td>

                    <td>
                      <div class="user-name">
                        <h5>{{ selectedProduct.name || "N/A" }}</h5>
                      </div>
                    </td>

                    <td>
                      <p>{{ selectedProduct.code || "N/A" }}</p>
                    </td>

                    <td>
                      <p>${{ utils.twoDecimalPlacesString(selectedProductPrice || 0) }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12 mb-4">
          <div class="form-group">
            <label for="product" class="form-label">Select Substitute Product*</label>
            <ng-select class="product-select" #product name="substituteProductId" [items]="customerPorductOptions"
              bindLabel="text" bindValue="id" [virtualScroll]="true" [searchable]="true" [clearable]="false"
              [(ngModel)]="substitutePayload.substituteProductId" [notFoundText]="noItemsFoundText"
              (scrollToEnd)="getCustomerProduct(true)" (search)="onCustomerProductSearch($event)"
              (close)="onCustomerProductSearch({ term: '' })" (change)="onCustomerProductChange($event.product)"
              placeholder="Select Product">
            </ng-select>
          </div>
        </div>

        <div class="col-12 mb-4" *ngIf="selectedSubstituteProduct">
          <div class="form-group">
            <div class="manage-table main-table table-responsive" [class.border]="
                selectedProduct.id === selectedSubstituteProduct.id
              " [class.border-danger]="
                selectedProduct.id === selectedSubstituteProduct.id
              ">
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <div class="product-name">
                        <span class="imgs">
                          <img src="{{
                              selectedSubstituteProduct.imageUrl ||
                                'https://placehold.co/600x400?text=No+Image'
                            }}" alt="product-1" />
                        </span>
                      </div>
                    </td>

                    <td>
                      <div class="user-name">
                        <h5>{{ selectedSubstituteProduct.name || "N/A" }}</h5>
                      </div>
                    </td>

                    <td>
                      <p>{{ selectedSubstituteProduct.code || "N/A" }}</p>
                    </td>

                    <td>
                      <p>${{ utils.twoDecimalPlacesString(selectedSubstituteProduct.price || 0) }} </p>

                      <p class="mt-2" [ngClass]="{
      'text-success': (selectedSubstituteProduct.price || 0) < selectedProductPrice,
      'text-danger': (selectedSubstituteProduct.price || 0) > selectedProductPrice
    }">
                        {{ getSelectedSubstitutePriceComparison() }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group mb-4">
            <label for="rule" class="form-label">Select Substitute Rule*</label>
            <select id="rule" class="form-select" [(ngModel)]="substitutePayload.substituteRule" name="substituteRule">
              <option value="null" disabled selected>Select a rule</option>
              <option value="AUTO_SWAP">Auto Swap</option>
              <option value="REQUIRE_APPROVAL_PER_ORDER">
                Require Approval Per Order
              </option>
            </select>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label for="note" class="form-label">Notes for Substitute Request{{ modalType === "SEND" ? "" : "*" }}
            </label>
            <textarea id="note" class="form-control" rows="4" placeholder="Enter note here..."
              [(ngModel)]="substitutePayload.note"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer gap-4">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="modal.close()">
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="onSubmitSubstituteRequest()">
        {{ this.modalType === "SEND" ? "Send Request" : "Override & Approve" }}
      </button>
    </div>
  </div>
</ng-template>
